export const industriesData = [
  {
    id: 1,
    name: 'Electrical',
    icon: 'ri-flashlight-line',
    image: 'https://public.readdy.ai/ai/img_res/a6f74e66955a829a007b3f9d30c8fdcb.jpg'
  },
  {
    id: 2,
    name: 'HVAC',
    icon: 'ri-temp-cold-line',
    image: 'https://readdy.ai/api/search-image?query=skilled%20HVAC%20technician%20installing%20modern%20air%20conditioning%20vent%20and%20thermostat%20in%20luxury%20home%20interior%20wall%20clean%20elegant%20residential%20setting%20with%20professional%20equipment%20bright%20interior%20lighting%20showing%20technical%20expertise%20commercial%20photography%20quality&width=800&height=600&seq=hvac-interior-002&orientation=landscape'
  },
  {
    id: 3,
    name: 'Landscaping',
    icon: 'ri-plant-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20interior%20plant%20designer%20arranging%20beautiful%20indoor%20plants%20and%20greenery%20in%20modern%20luxury%20home%20living%20space%20elegant%20pots%20sophisticated%20residential%20interior%20design%20bright%20natural%20window%20light%20showing%20expertise%20in%20biophilic%20design%20commercial%20photography%20quality&width=800&height=600&seq=land-interior-002&orientation=landscape'
  },
  {
    id: 4,
    name: 'Pest Control',
    icon: 'ri-bug-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20pest%20control%20technician%20in%20clean%20uniform%20inspecting%20modern%20home%20interior%20baseboards%20and%20walls%20with%20advanced%20detection%20equipment%20luxury%20residential%20setting%20bright%20interior%20lighting%20showing%20thoroughness%20and%20professionalism%20commercial%20photography%20quality&width=800&height=600&seq=pest-interior-002&orientation=landscape'
  },
  {
    id: 5,
    name: 'Plumbing',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=expert%20plumber%20installing%20modern%20elegant%20bathroom%20fixtures%20and%20faucets%20in%20luxury%20home%20interior%20marble%20countertops%20chrome%20finishes%20professional%20tools%20bright%20interior%20lighting%20showing%20craftsmanship%20and%20attention%20to%20detail%20commercial%20photography%20quality&width=800&height=600&seq=plumb-interior-002&orientation=landscape'
  },
  {
    id: 6,
    name: 'Roofing',
    icon: 'ri-home-4-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20contractor%20inspecting%20and%20repairing%20interior%20ceiling%20and%20attic%20structure%20in%20modern%20home%20wooden%20beams%20insulation%20professional%20equipment%20bright%20interior%20lighting%20showing%20structural%20expertise%20and%20quality%20workmanship%20commercial%20photography%20quality&width=800&height=600&seq=roof-interior-002&orientation=landscape'
  }
];
